"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setWord = setWord;
exports.hasWord = hasWord;
exports.getWord = getWord;
var dictionary = {};

function setWord(key, value) {
  dictionary[key.toLowerCase()] = value;
  return value;
}

function hasWord(key) {
  return key.toLowerCase() in dictionary;
}

function getWord(key) {
  return dictionary[key.toLowerCase()];
}